var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.knob,attrs:{"position":_vm.position},on:{"touchstart":function($event){$event.preventDefault();return _vm.handleStart($event)},"mousedown":function($event){$event.preventDefault();return _vm.handleStart($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }